// path: src/pages/IPA/Negociacoes/pages/NegociacaoFornecedor/components/TableFornecedor/layoutDasColunas.ts

/**
 * A largura e o alinhamento das colunas da grade, e só isso: ordem, quais aparecem, conteúdo das
 * células, cabeçalho e altura da linha moram em `TableFornecedor.tsx`.
 *
 * Três armadilhas: `width` desliga o `flexGrow`, cujo piso vai em `minWidth`; `alinhamento` só
 * onde já está escrito, porque ligá-lo torna a célula uma caixa flexível; `texto` só em Produto.
 */

export type AlinhamentoDaColuna = 'left' | 'center' | 'right';

export type ComportamentoDoTexto = 'quebra' | 'corta';

export type ChaveDaColuna =
  | 'seleção'
  | 'produto'
  | 'loja'
  | 'estoque'
  | 'margem objetiva'
  | 'custo atual'
  | 'novo custo'
  | 'verba de sell-in'
  | 'novo preço'
  | 'preço vigente'
  | 'preço concorrência'
  | 'preço ideal de compra'
  | 'aprovação';

export interface LayoutDaColuna {
  chave: ChaveDaColuna;
  titulo: string;
  width?: number;
  minWidth?: number;
  flexGrow?: number;
  alinhamento?: AlinhamentoDaColuna;
  /** Só a coluna Produto usa. Ausente vale como `'quebra'`. */
  texto?: ComportamentoDoTexto;
}

export const LAYOUT_DAS_COLUNAS: LayoutDaColuna[] = [
  { chave: 'seleção', titulo: '(a caixa de seleção)', width: 60, alinhamento: 'center' },

  { chave: 'produto', titulo: 'Produto', flexGrow: 1, minWidth: 200, texto: 'corta' },

  { chave: 'loja', titulo: 'Loja — "Rede" na visão por rede', width: 140, alinhamento: 'left' },
  { chave: 'estoque', titulo: 'Estoque', width: 120 },
  { chave: 'margem objetiva', titulo: 'Margem objetiva', width: 130 },

  { chave: 'custo atual', titulo: 'Custo atual', minWidth: 88 },

  { chave: 'novo custo', titulo: 'Novo custo', width: 165 },

  // Larga o bastante para a MAIOR linha de subtexto, não para o campo.
  { chave: 'verba de sell-in', titulo: 'Verba de sell-in', width: 290 },

  { chave: 'novo preço', titulo: 'Novo preço', width: 140 },
  { chave: 'preço vigente', titulo: 'Preço vigente', width: 130 },
  { chave: 'preço concorrência', titulo: 'Preço concorrência', width: 130 },
  { chave: 'preço ideal de compra', titulo: 'Preço ideal de compra', width: 116 },
  { chave: 'aprovação', titulo: '(aprovar ou reprovar o item)', width: 60, alinhamento: 'left' },
];

/** Estoura em vez de devolver vazio: sem layout a coluna sai estreita na tela, e não como falha. */
export const layoutDaColuna = (chave: ChaveDaColuna): LayoutDaColuna => {
  const layout = LAYOUT_DAS_COLUNAS.find(candidato => candidato.chave === chave);

  if (!layout) throw new Error(`a coluna "${chave}" não tem layout declarado em layoutDasColunas.ts`);

  return layout;
};

export interface DimensoesDaColuna {
  width?: number;
  minWidth?: number;
  flexGrow?: number;
  align?: AlinhamentoDaColuna;
}

/** Campo que a lista não declara sai daqui AUSENTE, e não com valor padrão. */
export const dimensoesDaColuna = (chave: ChaveDaColuna): DimensoesDaColuna => {
  const { width, minWidth, flexGrow, alinhamento } = layoutDaColuna(chave);

  return { width, minWidth, flexGrow, align: alinhamento };
};
